var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.97 7.56C26.07 7.95 25.14 8.22 24.15 8.34C25.17 7.74 25.95 6.78 26.31 5.61C25.35 6.18 24.3 6.57 23.19 6.81C22.29 5.85 21 5.25 19.59 5.25C16.86 5.25 14.67 7.47 14.67 10.17C14.67 10.56 14.7 10.92 14.79 11.28C10.71 11.1 7.10997 9.12 4.67997 6.15C2.93997 9.27 4.88997 11.85 6.17997 12.72C5.39997 12.72 4.61997 12.48 3.95997 12.12C3.95997 14.55 5.66997 16.56 7.88997 17.01C7.40997 17.16 6.32997 17.25 5.66997 17.1C6.29997 19.05 8.12997 20.49 10.26 20.52C8.57997 21.84 6.11997 22.89 2.96997 22.56C5.15997 23.97 7.73997 24.78 10.53 24.78C19.59 24.78 24.51 17.28 24.51 10.8C24.51 10.59 24.51 10.38 24.48 10.17C25.5 9.42 26.34 8.55 26.97 7.56Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6f305fe3d36f1002f6a58fbf2c7f6a65.svg";
export { ForwardRef as ReactComponent };